import React, { useEffect } from 'react'
import { useRouter } from 'hooks/useRouter'
import { useUserData } from 'state/user/hooks'
import useToast from 'hooks/useToast'
import _ from 'lodash'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import PageLoader from './components/PageLoader'

interface PageWrapperProps {
  children: React.ReactNode
  loading?: boolean
  error?: boolean
  pathname?: string
  noAccount?: boolean
  errorToastMessage?: string
}

const NoAccount: React.FC = () => (
  <Flex fullWidth minHeight="70vh" justifyContent="center" alignItems="center" flexDirection="column" p="32px">
    <Text variant={TextVariant.H4} mb="12px">
      Wallet required
    </Text>
    <Text variant={TextVariant.BODY_DEFAULT}>
      Connect your wallet from the header to view this page.
    </Text>
  </Flex>
)

const PageWrapper: React.FC<PageWrapperProps> = ({
  children,
  loading,
  error,
  pathname = '/',
  noAccount,
  errorToastMessage,
}) => {
  const { push, asPath } = useRouter()
  const { isLoading } = useUserData()
  const { toastError } = useToast()
  const showLoadingPage = loading || isLoading

  useEffect(() => {
    if (!_.isEmpty(errorToastMessage)) toastError(errorToastMessage)
  }, [errorToastMessage])

  useEffect(() => {
    if (error) push({ pathname }, undefined, { shallow: true })
    else push(asPath, undefined, { shallow: true })
  }, [loading, error, isLoading])

  const getContent = () => {
    if (noAccount && !isLoading && !loading) return <NoAccount />
    if (showLoadingPage) return <PageLoader />

    return children
  }

  return <>{getContent()}</>
}

export default PageWrapper
